import { useEffect } from "react";
import { useRouter } from "next/router";

import { Loading } from "@/shared/components";
import { Brand } from "@/shared/core/Brand";
// import { EcleticaCatalog } from "@/shared/core/EcleticaCatalog";
import { Holding } from "@/shared/core/Holding";
import { Store } from "@/shared/core/Store";
import { Table } from "@/shared/core/Table";

import { OrderStorage } from "@/storage/OrderStorage";

import { ServerSideFunction } from "shared/tools/ServerSideFunction";

import styles from "@/styles/pages/home.module.scss";
import { Flows } from "@/shared/core/Enum";

export const getServerSideProps = (context) => {
  return ServerSideFunction(context);
}

export default function Index() {
  const router = useRouter();
	const { code } = router.query || {};

  useEffect(() => {
    loadQrCode();
  }, [])

  const loadQrCode = async () => {
		try {
			await Table.loadQrCode(code);

			await Store.install(Table.storeAlias);
			await Store.setStore(Table.storeAlias);
			// await EcleticaCatalog.install(Table.storeAlias);

			OrderStorage.setFlow(Flows.OPEN_TABLE);

			await router.push(`/${Table.brandAlias}/cardapio`);
		} catch (err) {
			console.error(err);
			return await router.push(`/`);
		}
  }    

  return (
    <div className={styles.home}>
			<div className={styles.loading}>
				<Loading fullContent fullScreen />
			</div>
		</div>
	)

}
